module.exports = __webpack_public_path__ + "img/img-15.d2803a81.jpeg";